import React, { useContext, useEffect, useState } from 'react'
import { Switch, Route, useLocation, Redirect } from 'react-router-dom'
import SessionContext from '../context/session'
import { faunaAPI } from '../api/fauna-api'
import * as backendAPI from '../api/backend-api'

import Login from '../pages/login'
import Register from '../pages/register'
import Reset from '../pages/reset'
import Loading from './Loading'

export default function SessionLoaded(props) {

  const location = useLocation()
  const sessionContext = useContext(SessionContext)
  const { loggedIn, verified, sessionLifetime } = sessionContext.state
  const [isLoading, setLoading] = useState('session')

  const refreshOnce = async () => {
    console.log('INFO - Refreshing on load', new Date())

    backendAPI.getConfig().then(res => {
      Object.keys(res).forEach(key => {
        localStorage.setItem(key, res[key]);
      })
    })

    if (location.pathname.includes('reset')) {
      setLoading(false)
    } else {
      try {
        const res = await faunaAPI.refreshToken()
        if (!res.error) {
          console.log('INFO - Session found, logging in', res)
          sessionContext.dispatch({
            type: 'login',
            account: res.account.data,
            sessionLifetime: res.sessionLifetime
          })
        } else {
          console.log('INFO - There is no session')
        }
        setLoading(false)
      } catch (err) {
        console.log(err)
        setLoading(false)
      }
    }
  }

  const refreshSilent = async () => {
    console.log(
      'INFO - silent refreshing',
      new Date()
    )
    try {
      const res = await faunaAPI.refreshToken()
      sessionContext.dispatch({
        type: 'login',
        account: res.account.data,
        sessionLifetime: res.sessionLifetime
      })
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    if (loggedIn) {
      var id = null
      const delaySeconds = sessionLifetime * 0.75
      setTimeout(() => {
        id = setInterval(() => refreshSilent(), delaySeconds * 1000)
      }, delaySeconds)
      return () => clearInterval(id)
    } else {
      refreshOnce()
    }
  }, [loggedIn, verified])

  const accountsURIs = ["/accounts/login", "/accounts/register", "accounts/reset"]

  if (isLoading) {
    return <Loading />
  } else {
    if (loggedIn) {
      return props.children
    } else if (accountsURIs.includes(location.pathname)) {
      return (
        <Switch>
          <Route exact path="/accounts/login" component={Login} />
          <Route exact path="/accounts/register" component={Register} />
          <Route exact path="/accounts/reset" component={Reset} />
        </Switch>
      )
    } else {
      return <Redirect to="/accounts/login" />
    }
  }
}